module.exports = __webpack_public_path__ + "img/PLDT-Smart.f47ec190.png";